import React, { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';

const DatePickerButton = ({
	selectedDates,
	setSelectedDates,
	dates = [],
	name
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const ref = useRef(null);

	const togglePopup = () => setIsOpen(!isOpen);

	// Close popup when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (ref.current && !ref.current.contains(event.target)) {
				setIsOpen(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const formatDate = (date) => {
		let dateObj = new Date(date);
		const day = dateObj.getDate();
		const month = dateObj.toLocaleDateString('en-US', { month: 'short' });
		const year = dateObj.getFullYear();
		return `${day} ${month} ${year}`;
	};

	const dateOptions = [
		...new Set(dates.map((date) => formatDate(date))),
	];

	const handleDateClick = (dateOption) => {
		const newSelectedDates = new Set(selectedDates);

		if (selectedDates.has(dateOption)) {
			newSelectedDates.delete(dateOption);
		} else {
				newSelectedDates.add(dateOption);
			
		}

		setSelectedDates(newSelectedDates);

	};

	const isSelected = (dateId) => selectedDates.has(dateId);

	return (
		<div className="relative block text-left" ref={ref}>
			<button
				onClick={togglePopup}
				className={`px-4 py-2 w-full ${selectedDates.size > 0 ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'} rounded-xl shadow hover:bg-blue-500 hover:text-white transition`}
			>
				{name}
			</button>

			{isOpen && (
				<div className="absolute z-10 -left-28 mt-2 w-80 bg-white rounded-xl shadow-lg p-4 max-h-80 overflow-y-auto border-2">
					<div className=''>
						<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-1">
							{dateOptions.map((dateOption) => (
								<button
									key={dateOption}
									onClick={() => handleDateClick(dateOption)}
									className={`
					relative px-2 py-3 w-full rounded-lg border-2 transition-all duration-200 
					font-medium text-sm flex items-center justify-center
					transform hover:scale-105 active:scale-95
					${
											isSelected(dateOption)
												? 'bg-blue-500 text-white border-blue-500 shadow-lg shadow-blue-500/25'
												: 'bg-white text-gray-700 border-gray-200 hover:border-blue-300 hover:bg-blue-50'
										}
					${
											!isSelected(dateOption)
												? 'opacity-50 cursor-not-allowed hover:scale-100'
												: 'cursor-pointer'
										}
					focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50
					`}
								>
									{dateOption}
									{isSelected(dateOption) && (
										<div className="absolute -top-1 -right-1 w-5 h-5 bg-blue-600 rounded-full flex items-center justify-center">
											<svg
												className="w-3 h-3 text-white"
												fill="currentColor"
												viewBox="0 0 20 20"
											>
												<path
													fillRule="evenodd"
													d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
													clipRule="evenodd"
												/>
											</svg>
										</div>
									)}
								</button>
							))}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default DatePickerButton;
